import "./About.css";

const About = () => {
    return (
        <section className='about-spatial' id="about">
            <div className='bg-grid-overlay'></div>
            <div className='scanline'></div>

            <div className='spatial-container'>
                <div className='hero-about'>
                    <h2 className='massive-title'>
                        <span className='outline' data-text="SYSTEM">SYSTEM</span>
                        <span className='filled'>ARCHITECT</span>
                    </h2>
                </div>

                <div className='main-layout'>
                    <div className='bio-column'>
                        <div className='glass-card bio-card'>
                            <div className='card-glow'></div>
                            <span className='status-dot-container'>
                                <span className='status-dot'></span>
                                <span className='status-text'>LIVE_ENGINE_01</span>
                            </span>
                            <p>
                                Stéphane Kikoni — Ingénieur logiciel avec 5 ans d’expérience en Full-Stack.
                                Je transforme des idées en solutions numériques robustes, bien architecturées et conçues pour évoluer.
                            </p>
                        </div>

                        <div className='experience-badge-modern mt-5'>
                            <div className='exp-number'>06</div>
                            <div className='exp-text'>
                                <span>ANS DE </span>
                                <span>CODE PUR</span>
                            </div>
                        </div>
                    </div>

                    <div className='stack-column'>
                        <div className='stack-group'>
                            <h4 className='group-label'><span className='label-id'>[01]</span> CORE ENGINE</h4>
                            <div className='stack-tags-grid'>
                                {['Node.js', 'MySQL', 'Docker', 'Express', 'MongoDB', 'PostgreSQL'].map(tech => (
                                    <div key={tech} className='tech-tag-premium'>{tech}</div>
                                ))}
                            </div>
                        </div>

                        <div className='stack-group'>
                            <h4 className='group-label'><span className='label-id'>[02]</span> INTERFACES</h4>
                            <div className='stack-tags-grid'>
                                {['React', 'Next.js', 'React Native', 'TypeScript', 'Redux', 'Zustand'].map(tech => (
                                    <div key={tech} className='tech-tag-premium highlight'>{tech}</div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>

                <div className='stats-bar-cyber'>
                    {[
                        { val: '40+', key: 'Projets' },
                        { val: '99%', key: 'Uptime' },
                        { val: '100k', key: 'Lignes' }
                    ].map((stat, i) => (
                        <div className='stat-block' key={i}>
                            <span className='stat-val'>{stat.val}</span>
                            <span className='stat-key'>{stat.key}</span>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default About;